<template>
  <a-drawer
    v-model:visible="visible"
    title="转接方案"
    width="600px"
    :maskClosable="false"
    @close="handleCancel"
  >
    <div class="area">
      <div class="label">
        <img :src="requiredIcon" alt="" />
        转接方案
      </div>
      <div class="item-box z-flex">
        <div
          class="item"
          :class="{ active: bussObj.bussType === item.value }"
          v-for="item in bussOptions"
          :key="item.value"
          @click="handleBussType(item.value)"
        >
          <img v-show="bussObj.bussType === item.value" :src="activeIcon" alt="" />
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="area" v-if="bussObj.bussType === 1">
      <div class="label">
        <img :src="requiredIcon" alt="" />
        选择线路
      </div>
      <div>
        <a-radio-group :options="plainOptions" v-model:value="bussObj.subType" />
      </div>
    </div>
    <template v-if="bussObj.bussType === 2">
      <div class="area">
        <div class="label z-flex-c">
          <div>搜索人员</div>
          <a-button key="submit" type="primary" @click="handleRefresh">刷新</a-button>
        </div>

        <div class="search-item">
          <a-input
            class="search-input"
            v-model:value="bussObj.searchKey"
            size="large"
            placeholder="搜索姓名/字母/ID "
            allowClear
            :maxLength="50"
            @change="handleChange"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
      </div>
      <a-spin :spinning="loading">
        <div class="area seat-list" :class="{ searchList: bussObj.searchKey }">
          <div class="label" v-if="!bussObj.searchKey">
            可选列表
            <span class="tip">在班且坐席在线的人员</span>
          </div>
          <div class="seat-box" v-if="dataList.length > 0">
            <div
              class="item z-flex-c"
              v-for="it in dataList"
              :key="it.seatErpId"
              :class="{
                disabled: it.disabled,
                active: it.seatErpId === bussObj.activeItem.seatErpId
              }"
              @click="handleSeat(it)"
            >
              <div class="left">
                <div class="top">
                  <span class="role" :class="{ service: it.seatType === 9 }">
                    {{ it.seatType === 4 ? '健管' : '客服' }}
                  </span>
                  <span class="name" v-if="it.name">{{ it.name }}</span>
                  <span class="status" v-if="it.statusStr">{{ it.statusStr }}</span>
                </div>
                <div class="bottom">上次与该患者通话：{{ it.lastServiceTime }}</div>
              </div>
              <div class="right">
                <img
                  v-if="it.seatErpId === bussObj.activeItem.seatErpId"
                  :src="checkIcon"
                  class="circle-icon"
                  alt=""
                />
                <div class="circle" v-else></div>
              </div>
            </div>
          </div>
          <div class="empty" v-else>
            <empty :image="simpleImage" imageStyle="height: 100px" description="暂无数据" />
          </div>
        </div>
      </a-spin>
    </template>
    <div class="footer">
      <a-button key="back" @click="handleCancel" class="cancel">取消</a-button>
      <a-button key="submit" type="primary" @click="handleOk" :disabled="disabled">确认</a-button>
    </div>
  </a-drawer>
</template>
z

<script setup>
import { ref, defineExpose, reactive, computed, onUnmounted } from 'vue'
import { setSeatList } from '@/api/login'
import { useStore } from 'vuex'
import activeIcon from '@/assets/img/tccc/active.png'
import requiredIcon from '@/assets/img/tccc/required.png'
import checkIcon from '@/assets/img/tccc/check.png'
import { SearchOutlined } from '@ant-design/icons-vue'
import { debounce } from 'lodash-es'
import { callTransfer } from '@/utils/Tccc'
import { buildCallIntent } from '@/api/login'
import moment from 'moment'
import { Empty, message } from 'ant-design-vue'

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
const store = useStore()
const TcccUserInfo = computed(() => store.state.tccc.tcccUserInfo || {})
const disabled = computed(() => {
  return !(bussObj.subType || bussObj.activeItem?.seatEmail)
})
const loading = ref(false)
const dataList = ref([])
const bussOptions = [
  { label: '系统分配', value: 1 },
  { label: '指定人员', value: 2 }
]
const plainOptions = [
  { label: '转咨询线', value: '1' },
  { label: '转投诉线', value: '2' }
]
const defaultBussObj = {
  bussType: 1, // 转接方案 1-系统分配 2-指定人员
  subType: undefined, // 选择线路 1-咨询线 2-投诉线
  activeItem: {}, // 选中的坐席对象
  searchKey: '' // 搜索人员关键字
}
const bussObj = reactive({
  ...defaultBussObj
})

const visible = ref(false)
const seatListTimer = ref(null)
// 选择坐席
const handleSeat = item => {
  if (item.disabled) return message.error('未满足转接条件，无法选择！')
  if (item.seatErpId === bussObj.activeItem.seatErpId) {
    bussObj.activeItem = {}
  } else {
    bussObj.activeItem = item
  }
  if (bussObj.activeItem.seatEmail) {
    // 当已经选中了坐席之后，暂停轮询机制
    clearSeatListTimer()
  } else {
    setSeatListTimer()
  }
}
const handleOk = () => {
  //  指定转接坐席的时候：如果是客服人员就是投诉，健管就是咨询
  const afterIntent = bussObj.subType
    ? bussObj.subType
    : bussObj.activeItem.seatType === 4
    ? '1'
    : '2'
  const params = {
    afterIntent,
    tcccSessionId: TcccUserInfo.value.options.sessionId
  }
  buildCallIntent(params)
  if (bussObj.bussType === 1) {
    callTransfer({
      ivrKey: bussObj.subType
    })
  } else {
    callTransfer({
      userId: bussObj.activeItem?.seatEmail
    })
  }
  visible.value = false
}
const handleCancel = () => {
  clearSeatListTimer()
  visible.value = false
}
// 切换转接方案
const handleBussType = type => {
  Object.assign(bussObj, defaultBussObj)
  bussObj.bussType = type
  clearSeatListTimer()
  if (type === 2) {
    // 立即调用一次
    getSeatList()
    setSeatListTimer()
  }
}
// 手动刷新
const handleRefresh = () => {
  !loading.value && getSeatList()
}
// 设置定时器
const setSeatListTimer = () => {
  if (seatListTimer.value) return
  // 每5秒调用一次
  seatListTimer.value = setInterval(() => {
    getSeatList()
  }, 5000)
}
// 清除定时器
const clearSeatListTimer = () => {
  console.log('clearSeatListTimer')
  if (seatListTimer.value) {
    clearInterval(seatListTimer.value)
    seatListTimer.value = null
  }
}
// 获取坐席列表
const getSeatList = async () => {
  const mobile = TcccUserInfo?.value?.phone || ''
  if (!mobile) return clearSeatListTimer()
  loading.value = true
  const res = await setSeatList({
    searchKey: bussObj.searchKey,
    mobile
  }).catch(() => {
    loading.value = false
  })
  dataList.value = res.map(it => {
    it.lastServiceTime = it.lastServiceTime
      ? moment(it.lastServiceTime).format('YYYY-MM-DD HH:mm')
      : '未服务过'
    it.disabled = it.status !== 0
    if (bussObj.searchKey) {
      it.name = `${it.seatName}（ ID: ${it.seatErpId}）`
    } else {
      it.name = it.seatName
      it.statusStr = ''
    }
    return it
  })
  loading.value = false
  console.log('坐席列表', res)
}
// 输入框搜索
const handleChange = debounce(getSeatList, 500)
// 弹窗初始化
const initModal = () => {
  if (visible.value) return
  visible.value = true
  Object.assign(bussObj, defaultBussObj)
}
onUnmounted(() => {
  clearSeatListTimer()
})
defineExpose({
  initModal
})
</script>

<style scoped lang="scss">
.area {
  margin-bottom: 20px;
  ::v-deep(.ant-radio-group) {
    .ant-radio-wrapper {
      margin-right: 52px;
      font-size: 16px;
    }
  }
  .label {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    margin-bottom: 8px;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .item-box {
    .item {
      width: 270px;
      height: 60px;
      border-radius: 4px;
      background: #f5f5f5;
      border: 1px solid #f5f5f5;
      line-height: 60px;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      text-align: center;
      cursor: pointer;
      position: relative;
      &.active {
        background: #1890ff14;
        border-color: #1890ff;
        img {
          position: absolute;
          bottom: -1px;
          right: -1px;
          width: 24px;
          height: 22px;
        }
      }
    }
  }
}
.seat-list {
  &.searchList {
    padding: 12px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  .tip {
    font-weight: 400;
    font-size: 14px;
    color: #f78408;
    line-height: 20px;
    margin-left: 8px;
  }
  .seat-box {
    .item {
      border-radius: 8px;
      border: 1px solid #e3e3e3;
      padding: 12px;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      cursor: pointer;
      .left {
        flex: 1;
      }
      .top {
        .role {
          display: inline-block;
          width: 36px;
          height: 20px;
          border-radius: 4px;
          background: #f9f0ff;
          font-weight: 400;
          font-size: 12px;
          color: #722ed1;
          text-align: center;
          line-height: 20px;
          margin-right: 12px;
          &.service {
            color: #3bb600;
            background: #e4f8da;
          }
        }
        .name {
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 14px;
          margin-right: 6px;
        }
        .status {
          font-weight: 400;
          font-size: 14px;
          color: #ffa940;
        }
      }
      .bottom {
        margin-top: 12px;
        border-radius: 4px;
        background: #d8d8d833;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        padding: 6px 12px;
      }
      .right {
        margin: auto 6px auto 18px;
        .circle {
          width: 18px;
          height: 18px;
          border: 1px solid #999999;
          border-radius: 50%;
        }
        .circle-icon {
          width: 18px;
          height: 18px;
        }
      }
      &.disabled {
        opacity: 0.6;
        .circle {
          background: #f0f0f0;
          border-color: #99999999;
        }
      }
      &.active {
        border-color: #1890ffcc;
        background: #1890ff14;
      }
    }
  }
}
.footer {
  padding: 16px 24px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  border-top: 1px solid #00000017;
  text-align: right;
  .cancel {
    margin-right: 22px;
  }
}
</style>
